import { ScheduleOutlined } from '@ant-design/icons'
import type { ProtectedRouteDescriptor } from '@/routes/types'
import { permissions } from '@/types/authorization'
import { CapacityPlannerPage } from './page'
import { CapacityPlannerSettingsPage } from './settings/page'

export const capacityPlannerRouteDescriptors: ProtectedRouteDescriptor[] = [
  {
    key: 'capacity-planner',
    path: 'capacity-planner',
    element: <CapacityPlannerPage />,
    access: { anyOf: [permissions.viewCapacityPlanner] },
    nav: {
      sectionKey: 'practice',
      label: 'PracPlanner',
      Icon: ScheduleOutlined,
      order: 33,
    },
  },
  {
    key: 'capacity-planner-settings',
    path: 'capacity-planner/settings',
    element: <CapacityPlannerSettingsPage />,
    access: { anyOf: [permissions.viewCapacityPlanner] },
  },
]
